module.exports = __webpack_public_path__ + "img/folder-lock.363b8932.svg";